import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { sendSms, validateSms } from "../../api/smsApi";
import { registerAtom } from "../../recoil/atoms";

export const useSendSms = () => {
  const navigate = useNavigate();

  const onError = ({
    response: {
      data: { code, message },
    },
  }) => {
    if (code === "INVALID_PHONE" || code === "SMS_SEND_FAILURE") {
      alert(message);
      navigate(-1);
    }
  };
  const onSuccess = () => {};
  return useMutation(sendSms, {
    onError,
    onSuccess,
  });
};

export const useReSendSms = (setIsSmsSending) => {
  const onError = ({
    response: {
      data: { code, message },
    },
  }) => {
    if (code === "INVALID_PHONE" || code === "SMS_SEND_FAILURE") {
      alert(message);
    }
  };
  const onSuccess = () => {
    setIsSmsSending(false);
  };
  return useMutation(sendSms, {
    onError,
    onSuccess,
  });
};

// 인증 확인 훅
export const useValidateSms = () => {
  const navigate = useNavigate();

  const setRegisterAtom = useSetRecoilState(registerAtom);
  const onError = ({
    response: {
      status,
      data: { code, message },
    },
  }) => {};
  const onSuccess = ({ data: { isValid, message } }) => {
    if (!isValid) {
      setRegisterAtom((prev) => ({
        ...prev,
        smsMessage: message,
      }));
    } else {
      navigate("/register/info", { replace: true });
    }
  };
  return useMutation(validateSms, {
    onError,
    onSuccess,
  });
};
